export default function staticSponsors() {
  const widgetName = 'staticSponsors';
  const widgetOpts = staticSponsorsOpts;

  const wrapContainerClass = 'staticSponsors-wrap-container';

  const enableHeading = false;
  const headingTag = 'h2';
  const headingTitle = 'Grand Champion Sponsors';

  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  customTitleFeature();

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
        $widget.remove();
      }
    },
  });

  // *********************************************************
  // Function Helper
  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $sponsor = $(this);

      $sponsor.find('.card-content').remove();
      $sponsor.attr('title', Title);

      if (URL == null) {
        $sponsor.removeAttr('href');
      }
    });
  }

  function customTitleFeature() {
    if (enableHeading) {
      $(`.${wrapContainerClass} .inner-container`).prepend(
        `<${headingTag} class="staticSponsors-sponsors-title">${headingTitle}</${headingTag}>`,
      );
    }
  }
}
